import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, ref, toRefs, } from 'vue';
import { shareStoreListTableHeader } from '@/constants/shareManagement';
import ShareStoreListTableRow from '@V/ShareManagement/ShareList/ShareStoreListTableRow.vue';
import { i18n } from '@/locales';
import { sortTypeEnum } from '@/constants/global';
import vuexStore from '@/vuex-store';
import TotalCount from '@/components/TotalCount.vue';
const lc = 'views.share_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShareStoreListTable',
    props: {
        isFetching: {},
        isError: {}
    },
    setup(__props) {
        const props = __props;
        const getterShareStoreListLength = computed(() => vuexStore.getters['shareManagement/shareList/getterShareStoreListLength']);
        const { isFetching, isError } = toRefs(props);
        const sortBy = ref([
            {
                key: 'storeName',
                order: sortTypeEnum.ASC,
            },
        ]);
        const getterShareStoreList = computed(() => vuexStore.getters['shareManagement/shareList/getterShareStoreList']);
        const getterSelectedRowShareInfo = computed(() => vuexStore.getters['shareManagement/shareList/getterSelectedRowShareInfo']);
        const localeInfo = computed(() => {
            if (isFetching.value) {
                return {
                    noDataText: i18n.t('common.on_fetching'),
                };
            }
            if (isError.value) {
                return {
                    noDataText: i18n.t('common.data_can_not_load'),
                };
            }
            return ({
                noDataText: getterSelectedRowShareInfo.value
                    ? i18n.t(`${lc}share_store_table_no_data_text`)
                    : i18n.t(`${lc}no_selected_hub_text`),
            });
        });
        return (_ctx, _cache) => {
            const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(TotalCount, null, {
                    default: _withCtx(() => [
                        _createTextVNode(" 총 " + _toDisplayString(getterShareStoreListLength.value) + " 건 ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_data_table_virtual, {
                    hover: "",
                    class: "share-store-list-data-table brg-table brg-table-pd-x-thin",
                    "hide-default-footer": "",
                    "must-sort": "",
                    "fixed-header": "",
                    "no-data-text": localeInfo.value.noDataText,
                    items: getterShareStoreList.value,
                    headers: _unref(shareStoreListTableHeader),
                    "sort-by": sortBy.value,
                    "items-per-page": -1,
                    density: "compact",
                    "item-height": "37"
                }, {
                    bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
                    [`item`]: _withCtx(({ item }) => [
                        _createVNode(ShareStoreListTableRow, {
                            item: item
                        }, null, 8 /* PROPS */, ["item"])
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["no-data-text", "items", "headers", "sort-by"])
            ]));
        };
    }
});
